//- wishlist 英文対応
// let maxWaitTime = 2000;
// let intervalTime = 10;
// let elapsedTime = 0;
// let intervalId = setInterval(function() {
//   let element = document.querySelector(".empty-wishlist");
//   if (element) {
//     element.textContent = "Wishlist not yet registered";
//     clearInterval(intervalId);
//   } else {
//     elapsedTime += intervalTime;
//     if (elapsedTime >= maxWaitTime) {
//       clearInterval(intervalId);
//     }
//   }
// }, intervalTime);




//- product description accordion
let baseHeight = 0;
const descriptionWrapperP = document.querySelector('.description-wrapper p'); // ('.description-wrapper p');
const descriptionWrapper = document.querySelector('.description-wrapper'); // .description-wrapperへの参照を追加

const updateBaseHeight = () => {
  baseHeight = descriptionWrapperP.offsetHeight;
  descriptionWrapper.style.maxHeight = '1000px';
};

updateBaseHeight();
window.addEventListener('resize', function () {
  updateBaseHeight();
});


